export default "__VITE_ASSET__B7G4yCLT__"